define("command-palette/constants/index", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.SearchCommandResultType = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  let SearchCommandResultType = _exports.SearchCommandResultType = /*#__PURE__*/function (SearchCommandResultType) {
    SearchCommandResultType["Live"] = "live";
    SearchCommandResultType["PreviouslyUsed"] = "previously-used";
    SearchCommandResultType["Suggested"] = "suggested";
    return SearchCommandResultType;
  }({});
});